import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Button, message } from 'antd';
import { Link, NavLink, useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { metamaskState } from 'global/state';
import { Network } from 'components/utils';
import web3 from 'global/web3';


const Header = (props) => {
  const history = useHistory();
  const [ metamask, setMetamask ] = useRecoilState(metamaskState);


  // connect to metamask
  const connectToMetaMask = async () => {
    if ( metamask?.connected ) { return; }
    if ( window.ethereum ) {
      try {
        const response = await window.ethereum.enable();
        if ( response && response.length > 0 ) {
          const address = response[0];
          const network = window.ethereum.networkVersion;
          const networkId = network ? parseInt(network) : parseInt(await web3.eth.net.getId());

          if ( networkId !== Network.BSC && networkId !== Network.ETHEREUM ) {
            message.error('Error: Please select a Valid Network');
            return;
          }
          setMetamask({
            connected: true,
            address: address,
            network: networkId,
          });

          if ( networkId === Network.BSC ) {
            message.success('Successfully Connected to Binance Smart Chian Network!');
            history.push('/binance-smart-chain');
          } else if ( networkId === Network.ETHEREUM ) {
            message.success('Successfully Connected to Ethereum Network!');
            history.push('/ethereum');
          }

        }
      } catch (error) {
        console.log('error', error)
        message.error(`Error occured: ${error}`);
      }
    }
  }



  return (
    <HeaderContainer>
      <Logo>
        <Link to="/">Crypto Token Generator</Link>
      </Logo>
      <Nav>
        <NavInner>
          <NavLink exact activeClassName="active" to="/">Home</NavLink>
          <NavLink activeClassName="active" to="/binance-smart-chain" >Binance Smart Chain</NavLink>
          <NavLink activeClassName="active" to="/ethereum">Ethereum</NavLink>
        </NavInner>
      </Nav>
      <RightNav>
        <CustomButton type="primary" onClick={ connectToMetaMask } className={ metamask.connected ? 'connected' : '' }>
          { metamask.connected ? ( metamask?.network === Network.BSC ? `BSC: ${metamask.address.substring(0, 15)}` : `Ethereum: ${metamask.address.substring(0, 15)}` ) : 'Connect to MetaMask' }
        </CustomButton>
      </RightNav>
    </HeaderContainer>
  )
}

export default Header;


const HeaderContainer = styled.header`
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // border-bottom: 2px solid #28364c;
  font-family: 'Balsamiq Sans', cursive;


  @media only screen and (max-width: 600px) {
    flex-direction: column;
    padding-bottom: 0;
  }

`;


const Logo = styled.h1`
  flex: 1;
  font-size: 22px;
  color: #fff;
  line-height: 100%;
  margin: 0;
  a {
    color: #fff;
  }

  @media only screen and (max-width: 600px) {
    margin-bottom: 20px;
  }


`;

const Nav = styled.nav`
  background: rgb(25, 27, 31);
  padding: 4px;
  border-radius: 10px;
  display: flex;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
    display: none;
  }

  a {
    display: block;
    font-size: 16px;
    color: rgb(195, 197, 203);
    border-radius: 10px;
    padding: 5px 10px;
    font-weight: 400;

    &.active {
      color: #fff;
      background-color: rgb(44, 47, 54);
      font-weight: 700;
    }
  }

`;
const NavInner = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }

`;


const RightNav = styled.div`
  flex: 1;
  text-align: right;
`;


const CustomButton = styled(Button)`
  background-color: rgb(44, 47, 54);
  border-color: #262b38;
  font-weight: 700;

  &:hover {
    background-color: #37383c;
    border-color: #353842;
  }
  &.connected {
    background-color: #4caf50;
  }
`;




/*
   import { Link } from 'react-router-dom';
     <Link to="">Dashboard</Link>
        <Link to="">Packages</Link>
        <Link to="">Features</Link>

*/
